var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_288_4",
    "data-name": "Komponente 288 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25715",
    "data-name": "Rechteck 25715",
    width: 24,
    height: 24,
    fill: "#ffffff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25716",
    "data-name": "Rechteck 25716",
    width: 40,
    height: 40,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown-administrator",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19972",
    "data-name": "Gruppe 19972",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291292",
    "data-name": "Pfad 291292",
    d: "M23.05,10A1.252,1.252,0,0,0,21.8,8.75a1.234,1.234,0,0,0-1.2.985c-3.744-.118-6.762-1.866-7.9-4.562a1.375,1.375,0,1,0-1.417,0C10.162,7.856,7.166,9.6,3.446,9.732a1.234,1.234,0,0,0-1.2-.982,1.243,1.243,0,0,0-.073,2.485l1.748,5.849V20.5a.575.575,0,0,0,.575.575h15a.576.576,0,0,0,.575-.575V17.084l1.744-5.838A1.249,1.249,0,0,0,23.05,10m-4.1,6.835a.578.578,0,0,0-.024.165v2.925H5.075V17a.578.578,0,0,0-.024-.165L3.279,10.906C7.2,10.828,10.461,9.109,12,6.393c1.537,2.716,4.8,4.435,8.722,4.513Z",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownWhiteIcon);
export default __webpack_public_path__ + "static/media/crown_white_icon.c6adf840847be77e21b37b11904b3a7c.svg";
export { ForwardRef as ReactComponent };